import { render, staticRenderFns } from "./onlineInteraction.vue?vue&type=template&id=fe135bb0"
import script from "./onlineInteraction.vue?vue&type=script&lang=js"
export * from "./onlineInteraction.vue?vue&type=script&lang=js"
import style0 from "./onlineInteraction.vue?vue&type=style&index=0&id=fe135bb0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports